import ZmButton from '@/components/zoom-ui-plus/button/index.vue';
import { h } from 'vue';

export const vnode = (message, events) => {
  return h('div', {
    role: 'alertdialog',
    'aria-label': 'message',
    'aria-describedby': 'message-dialog-desc',
  }, [
    h('p', {
      style: {
        paddingRight: '32px',
      },
    }, [
      h('span', {
        id: 'message-dialog-desc',
      }, message),
      h(ZmButton, {
        type: 'link',
        class: {
          'mgl-sm': true,
        },
        onClick: (...args) => events(...args),
      }, 'Undo Change'),
    ]),
  ]);
};
